"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _vuex = require("vuex");

var _AffaireList = _interopRequireDefault(require("@/components/AffaireList"));

var _listClient = _interopRequireDefault(require("@/components/listClient"));

var _listEnseigne = _interopRequireDefault(require("@/components/listEnseigne"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'FactureIndex',
  components: {
    ListClient: _listClient.default,
    ListEnseigne: _listEnseigne.default,
    AffaireList: _AffaireList.default
  },
  data: function data() {
    return {
      refresh: 0,
      activeFilter: '',
      filters: {
        idClient: null,
        idEnseigne: null,
        numeroAffaire: null
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      handler: function handler(newValue) {
        // Sauvegarde des filtres dans le localStorage
        localStorage.setItem("Filters_".concat(this.pageIdent), JSON.stringify(this.filters));
      }
    }
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    pageIdent: function pageIdent() {
      return "".concat(this.user.id_societe, "-VenteCreance-FacturesDeVente");
    },
    infoIsVisible: function infoIsVisible() {
      return this.activeFilter === '';
    },
    filterExists: function filterExists() {
      var filterExists = false;
      Object.values(this.filters).forEach(function (x, index) {
        // console.log(index + '# typeof', x, typeof x)
        switch (_typeof(x)) {
          case 'string':
            if (x !== null && x !== '') {
              // console.log('A.' + index + '# typeof', x, typeof x)
              filterExists = true;
            }

            break;

          case 'number':
            if (x !== null && x > 0) {
              // console.log('B.' + index + '# typeof', x, typeof x)
              filterExists = true;
            }

            break;

          case 'object':
            if (x && x.length > 0) {
              // console.log('C.' + index + '# typeof', x, typeof x)
              filterExists = true;
            }

            break;
        }
      });
      return filterExists;
    }
  }),
  beforeMount: function beforeMount() {
    // Récupération des filtres sauvegardés
    var savedFilters = localStorage.getItem("Filters_".concat(this.pageIdent));

    if (savedFilters) {
      this.filters = JSON.parse(savedFilters);
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getAffaires();

            case 2:
              this.refresh++;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: _objectSpread({}, (0, _vuex.mapActions)('affaire', ['getAffaires']), {
    handleManageFacture: function handleManageFacture(_ref) {
      var index = _ref.index,
          row = _ref.row,
          nextTickEventName = _ref.nextTickEventName;
      this.$loader(true);
      this.$router.push({
        name: 'VenteCreance.Factures.ListByAffaire',
        params: {
          affaireId: row.id,
          nextTickEventName: nextTickEventName
        }
      });
    }
  })
};
exports.default = _default;